module.exports = __webpack_public_path__ + "img/cannery-6.d928cc6b.jpg";